import PropTypes from "prop-types";
import "../dashboard-cme/dashboard-cme.scss";
import React, { useState, useEffect } from "react";
import { getLastUpdatedDateColor, getLastUpdatedTootlTip } from "../dashboard-util/dashboard-utils";
import { Modal } from "react-bootstrap";
import PlanningToWork from "./PlanningToWork";

const ProjectTimeLogModal = ({project, show, onHide}) => {
    const [members, setMembers] = useState(project.HoursLog);

    useEffect(() => {
        if (project.HoursLog) setMembers(project.HoursLog);
    }, [project]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
            >
                <Modal.Title className="dashboard-modal-title ml-4 ">
                    {project?.ProjectName ?? ""}
                    <p className="subDepartmentTitle">Project Time Log</p>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="cmeModalBody">
                <table className="CMEDashboard">
                    <thead className="MemberTableColumnHeader cmeHeader">
                        <tr className="tableColumnTitles tableHeader">
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Analyst/Associate Name</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Hours worked in current week</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Planning to work on the weekend</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Estimated hours for the next week</th>
                            {getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                        </tr>
                    </thead>
                    <tbody className="tableBody cmeBody">
                        {members.length > 0 &&
                            members?.map((pm) => {
                                return (
                                    <tr key={pm?.UserId} style={{height:"47px"}}>
                                        <td className="col-md-1 col-sm-1 mt-2" style={{font:"14px"}}>
                                            {pm.Name}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.HoursThisWeek}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            <PlanningToWork WorkingWeekend={pm.WorkingWeekend || false} />
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.HoursNextWeek}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2" style={{ color: getLastUpdatedDateColor(pm.LastUpdated) }}>
                                            {pm.LastUpdated ?? "-"}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>

    );
};

export default React.memo(ProjectTimeLogModal);

ProjectTimeLogModal.propTypes = {
    project: PropTypes.arrayOf(
        PropTypes.shape({
            ProjectId: PropTypes.number.isRequired,
            ProjectName: PropTypes.string.isRequired,
            OwnerUserId: PropTypes.number.isRequired,
            OwnerUserName: PropTypes.string,
            ProjectMembersList: PropTypes.arrayOf(PropTypes.shape({
                UserId: PropTypes.number.isRequired,
                UserName: PropTypes.string,
                UserNameFull: PropTypes.string,
                Initials: PropTypes.string
            })),
            Status: PropTypes.string,
            StatusColor: PropTypes.string,
            HoursWorkedInCurrentWeek: PropTypes.number,
            CountWorkingOnTheWeekend: PropTypes.number,
            HoursForTheNextWeek: PropTypes.number,
            MD: PropTypes.string,
            D: PropTypes.string,
            VP: PropTypes.string,
            Associate: PropTypes.string,
            Analyst: PropTypes.string,
            Description: PropTypes.string,
            LastUpdated: PropTypes.string,
            Active: PropTypes.number.isRequired
        })
    ),
    show: PropTypes.bool,
    onHide: PropTypes.func
};